var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.$store.getters.user)?_c('v-footer',{style:({background: _vm.$vuetify.theme.themes.light.appBar, color: _vm.$vuetify.theme.themes.light.primary})},[_c('v-col',{staticClass:"text-center"},[_vm._v(" © 2025 "),_c('strong',[_vm._v("pebero")]),_vm._v(". All rights reserved. Images by freepik ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }